import { render, staticRenderFns } from "./guest.vue?vue&type=template&id=2052d23a&scoped=true"
import script from "./guest.vue?vue&type=script&lang=js"
export * from "./guest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2052d23a",
  null
  
)

export default component.exports